import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingHouseLine } from 'shared/selectors/jsonQuery';
import { EHouseLineType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Первая', value: EHouseLineType.First },
  { label: 'Вторая', value: EHouseLineType.Second },
];

export const selectBuildingHouseLineFilter = createSelector(selectBuildingHouseLine, value => ({
  label: 'Линия домов',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
